import React from "react";
import '../component.scss'
import AwanDigital from "../../assets/images/logo/awandigital.png"
import { Link } from 'react-router-dom'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fab } from '@fortawesome/free-brands-svg-icons'
library.add(fab)

export default function Footer() {
    return (
        <div className='relative footer md:h-[750px] w-full'>
            <div className="content w-full mx-auto max-w-[1280px] md:pt-[35px] md:px-[2rem]">
                {/* for desktop */}
                <div className="hidden md:block md:grid md:grid-cols-12 w-full">
                    <div className="col-span-5 left">
                        <img src={AwanDigital} alt="" />
                        <p className="text">
                            Awan digital merupakan platform penyedia aplikasi dari <br />
                            berbagai macam solusi yang membantu <br />
                            mentransformasi pekerjaan manual menjadi digital
                        </p>
                    </div>
                    <div className="col-span-3 right">
                        <h3 className="title">Lainnya</h3>
                        <ul>
                            <li><a href="/">Tentang Kami</a></li>
                            <li><Link to="/syarat-dan-ketentuan">Syarat & Kebijakan</Link></li>
                            <li><Link to="/kebijakan-privasi">Kebijakan Privasi</Link></li>
                        </ul>
                    </div>
                    <div className="col-span-2 right">
                        <h3 className="title">Produk</h3>
                        <div className="grid grid-cols-12">
                            <div className="col-span-6">
                                <ul>
                                    <li><a href="https://www.kyoo.id/">Kyoo</a></li>
                                    <li><a href="https://www.siqasir.com">Siqasir</a></li>
                                    <li><a href="https://sikas.netlify.app/">Sikas</a></li>
                                    <li><a href="/">Skrin</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-2 flex justify-end right">
                        <div>
                            <h3 className="title">Contact</h3>
                            <ul>
                                <li className="flex">
                                    <div className="w-[18px] h-[18px] bg-[#DDDDF8]">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.3973 4.26705C7.9161 3.64521 7.06892 3.43477 6.34306 3.73678C6.24151 3.77904 6.13542 3.83913 5.98952 3.92176L5.97437 3.93035L5.96604 3.93506L5.95793 3.94012C5.63499 4.14159 5.42306 4.44868 5.28282 4.75788C5.14198 5.06839 5.06005 5.40993 5.01261 5.724C4.92492 6.30451 4.94433 6.87074 4.98196 7.10562C4.98269 7.11607 4.98365 7.12806 4.98495 7.1416C4.98894 7.18333 4.99604 7.23981 5.00863 7.31166C5.03381 7.45534 5.08095 7.66049 5.16911 7.93219C5.34532 8.47523 5.686 9.28596 6.34534 10.4061C7.00501 11.5267 7.5829 12.2764 8.0027 12.7509C8.21257 12.9881 8.38277 13.1563 8.50372 13.2677C8.56418 13.3234 8.61231 13.3648 8.64689 13.3934C8.66419 13.4078 8.67809 13.4189 8.68845 13.4271L8.69953 13.4357C9.00234 13.6794 9.50857 14.0039 10.0763 14.2069C10.6357 14.4071 11.3467 14.521 11.9783 14.1979L11.9868 14.1935L11.9951 14.1888L12.0169 14.1765C12.1587 14.0963 12.2639 14.0367 12.351 13.9723C12.9854 13.5032 13.2261 12.6678 12.9151 11.9421C12.8726 11.8429 12.8117 11.7394 12.7314 11.6032L12.7185 11.5812L12.5802 11.3462L12.5691 11.3274C12.4295 11.0902 12.318 10.9007 12.2102 10.7574C12.0682 10.5686 11.8793 10.4587 11.7346 10.3892C11.5346 10.2933 11.3121 10.2549 11.1142 10.2369C10.913 10.2185 10.6998 10.2185 10.5083 10.2194L10.4588 10.2197C10.2791 10.2206 10.1187 10.2214 9.97124 10.2124C9.80798 10.2025 9.69764 10.1819 9.6275 10.1549C9.58988 10.1404 9.55266 10.1233 9.51596 10.1036C9.47724 10.0828 9.45509 10.0676 9.44117 10.0559C9.3246 9.95737 9.01955 9.67355 8.73596 9.19179C8.40414 8.62807 8.35902 8.23179 8.35552 8.19573C8.34985 8.09012 8.36016 7.98477 8.3854 7.882C8.40484 7.80282 8.45047 7.69513 8.52729 7.55036C8.58059 7.4499 8.63858 7.35004 8.70187 7.24105C8.73021 7.19225 8.75961 7.14163 8.79013 7.08829C8.88342 6.92526 8.98322 6.74333 9.05894 6.56003C9.1334 6.37981 9.19889 6.16524 9.19549 5.94042C9.19398 5.84043 9.18488 5.6979 9.12886 5.5501C9.05721 5.3611 8.933 5.15018 8.77565 4.88297L8.75565 4.849L8.61717 4.61409L8.60221 4.58866C8.52329 4.45449 8.46292 4.35185 8.3973 4.26705Z" fill="#5557DB" />
                                        </svg>
                                    </div>

                                    <div className="pl-[5px]">
                                        <p className="support">
                                            Support@awandigital.id
                                        </p>
                                    </div>
                                </li>
                                <li>
                                    <ul className="flex gap-x-[16px] justify-start social">
                                        <li><a href="/"><FontAwesomeIcon icon="fa-brands fa-facebook-f" /></a></li>
                                        <li><a href="/"><FontAwesomeIcon icon="fa-brands fa-twitter" /></a></li>
                                        <li><a href="/"><FontAwesomeIcon icon="fa-brands fa-instagram" /></a></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="hidden md:block w-full flex flex-wrap items-center">
                    <div className="text-center awan-digital">
                        © Copyright 2022 Awan Digital
                    </div>
                </div>

                {/* for mobile */}
                <div className="md:hidden mobile">
                    <h3>Produk</h3>
                    <div className="grid grid-cols-1 gap-x-[87px]">
                        <div className="col-span-1">
                            <ul className="menu">
                                <li><a className="p-0 m-0" href="https://www.kyoo.id/">Kyoo</a></li>
                                <li><a className="p-0 m-0" href="https://www.siqasir.com">Siqasir</a></li>
                                <li><a className="p-0 m-0" href="https://sikas.netlify.app/">Sikas</a></li>
                                <li><a className="p-0 m-0" href="/">Skrin</a></li>
                            </ul>
                        </div>
                    </div>

                    <h3>Lainnya</h3>
                    <ul className="menu">
                        <li><a className="p-0 m-0" href="/">Tentang Kami</a></li>
                        <li><Link className="p-0 m-0" to="/syarat-dan-ketentuan">Syarat & Kebijakan</Link></li>
                        <li><Link className="p-0 m-0" to="/kebijakan-privasi">Kebijakan Privasi</Link></li>
                    </ul>

                    <h3>Support</h3>

                    <div className="flex flex-wrap gap-x-[13px] rounded-[2px] md:border-b-[1px] border-[#535E80] pb-[37px]">
                        <div className="w-[18px] h-[18px] bg-[#DDDDF8]">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.3973 4.26705C7.9161 3.64521 7.06892 3.43477 6.34306 3.73678C6.24151 3.77904 6.13542 3.83913 5.98952 3.92176L5.97437 3.93035L5.96604 3.93506L5.95793 3.94012C5.63499 4.14159 5.42306 4.44868 5.28282 4.75788C5.14198 5.06839 5.06005 5.40993 5.01261 5.724C4.92492 6.30451 4.94433 6.87074 4.98196 7.10562C4.98269 7.11607 4.98365 7.12806 4.98495 7.1416C4.98894 7.18333 4.99604 7.23981 5.00863 7.31166C5.03381 7.45534 5.08095 7.66049 5.16911 7.93219C5.34532 8.47523 5.686 9.28596 6.34534 10.4061C7.00501 11.5267 7.5829 12.2764 8.0027 12.7509C8.21257 12.9881 8.38277 13.1563 8.50372 13.2677C8.56418 13.3234 8.61231 13.3648 8.64689 13.3934C8.66419 13.4078 8.67809 13.4189 8.68845 13.4271L8.69953 13.4357C9.00234 13.6794 9.50857 14.0039 10.0763 14.2069C10.6357 14.4071 11.3467 14.521 11.9783 14.1979L11.9868 14.1935L11.9951 14.1888L12.0169 14.1765C12.1587 14.0963 12.2639 14.0367 12.351 13.9723C12.9854 13.5032 13.2261 12.6678 12.9151 11.9421C12.8726 11.8429 12.8117 11.7394 12.7314 11.6032L12.7185 11.5812L12.5802 11.3462L12.5691 11.3274C12.4295 11.0902 12.318 10.9007 12.2102 10.7574C12.0682 10.5686 11.8793 10.4587 11.7346 10.3892C11.5346 10.2933 11.3121 10.2549 11.1142 10.2369C10.913 10.2185 10.6998 10.2185 10.5083 10.2194L10.4588 10.2197C10.2791 10.2206 10.1187 10.2214 9.97124 10.2124C9.80798 10.2025 9.69764 10.1819 9.6275 10.1549C9.58988 10.1404 9.55266 10.1233 9.51596 10.1036C9.47724 10.0828 9.45509 10.0676 9.44117 10.0559C9.3246 9.95737 9.01955 9.67355 8.73596 9.19179C8.40414 8.62807 8.35902 8.23179 8.35552 8.19573C8.34985 8.09012 8.36016 7.98477 8.3854 7.882C8.40484 7.80282 8.45047 7.69513 8.52729 7.55036C8.58059 7.4499 8.63858 7.35004 8.70187 7.24105C8.73021 7.19225 8.75961 7.14163 8.79013 7.08829C8.88342 6.92526 8.98322 6.74333 9.05894 6.56003C9.1334 6.37981 9.19889 6.16524 9.19549 5.94042C9.19398 5.84043 9.18488 5.6979 9.12886 5.5501C9.05721 5.3611 8.933 5.15018 8.77565 4.88297L8.75565 4.849L8.61717 4.61409L8.60221 4.58866C8.52329 4.45449 8.46292 4.35185 8.3973 4.26705Z" fill="#5557DB" />
                            </svg>
                        </div>

                        <div>
                            <p className="support">
                                Support@awandigital.id
                            </p>
                        </div>
                    </div>

                    <ul className="flex gap-x-[16px] justify-start social">
                        <li><a href="/"><i className="fab fa-facebook-f"></i></a></li>
                        <li><a href="/"><i className="fab fa-twitter"></i></a></li>
                        <li><a href="/"><i className="fab fa-instagram"></i></a></li>
                    </ul>

                    <img src={AwanDigital} alt="" />



                    <div className="social-media">
                        <div>
                            <p className="copy-right">© Copyright 2022 Awan Digital</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}